import { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import { EntityContentBlueprint } from "@backstage/plugin-catalog-react/alpha";
import { isArgocdAvailable } from "@roadiehq/backstage-plugin-argo-cd";

/**
 * ArgoCD deployment tab for Component entity pages.
 *
 * Shows the ArgoCD sync/health overview and deployment history. Conditionally
 * displayed via `isArgocdAvailable`, which checks for any of the ArgoCD
 * annotations (argocd/app-name, argocd/app-selector, argocd/project-name).
 *
 * The loader uses a dynamic import of ArgoCdTabContent.tsx for code splitting
 * -- Roadie ArgoCD components are excluded from the main bundle until the tab
 * is first opened.
 */
export const argocdContent: ExtensionDefinition = EntityContentBlueprint.make({
    name: "argocd",
    params: {
        path: "/argocd",
        title: "ArgoCD",
        filter: isArgocdAvailable,
        loader: async () => {
            const { ArgoCdTabContent } = await import("./ArgoCdTabContent");
            return <ArgoCdTabContent />;
        },
    },
});
